import { useState, forwardRef } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useResolvedPath,
} from "react-router-dom";
import "./styles.scss";

type Props = {
  title: string;
  img: string;
  friendlyUrl: string;
  sku?: string;
};

const ProductCard = forwardRef<HTMLDivElement, Props>(
  ({ title, img, friendlyUrl, sku }, ref) => {
    const [imgMain] = useState<string>(
      img.includes("|") ? img.split("|")[0] : img
    );

    const navigate = useNavigate();
    const location = useLocation();

    const handleOnClick = () => {
      if (/.*(category|search).*/.test(location?.pathname)) {
        localStorage.setItem("scrollY", window.scrollY.toString());
      }
      navigate(`/producto/${friendlyUrl}`);
    };

    return (
      <div className={"product_img"} ref={ref} onClick={handleOnClick} id={sku}>
        {imgMain ? (
          <img
            src={imgMain}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = "https://assets.rtabak.com.ar/rtabak.png";
            }}
          />
        ) : (
          <img src="https://assets.rtabak.com.ar/rtabak.png"></img>
        )}
        <div className="product_gradient"></div>
        <div className="product_title">
          <p className="product_title_title product_title_height">{title}</p>
          <p className="product_title_title product_sku_color">{sku}</p>
          <div>
            <p className="product_btn">Agregar</p>
          </div>
        </div>
      </div>
    );
  }
);
export default ProductCard;
